module.exports = __webpack_public_path__ + "static/img/strength2.b86759c6.png";